import React from 'react';

const Footer: React.FC = () => {
  return (
    <footer className="bg-appbg px-6 pb-8 pt-10 lg:px-20">
      <div className="mx-auto max-w-[1728px]">
        <div className="overflow-hidden rounded-[40px] border border-line bg-gradient-to-b from-primary-50 to-card px-8 py-10 sm:px-12 lg:px-16">
          <div className="grid gap-10 lg:grid-cols-[1.3fr_1fr_1fr_0.8fr]">
            <div className="space-y-4 text-ink">
              <h3 className="text-[24px] font-extrabold leading-none tracking-[-0.02em]">FlintPay</h3>
              <p className="text-[14px]">Copyright © 2026, All Rights Reserved</p>
              <div className="space-y-1 text-[14px] text-muted">
                <p className="font-semibold text-ink">FlintPay Private Limited</p>
                {/* <p>CIN - U74994HR2022PTC100843</p>
                <p>4th Floor, Plot No 48, AIHP Executive Centre, Sector 32, Gurugram, Haryana, 122001</p> */}
              </div>
            </div>

            <div className="space-y-5 text-[14px] text-ink">
              <div>
                <h4 className="text-[24px] font-bold tracking-[-0.01em]">Company</h4>
                <ul className="mt-3 space-y-2 text-muted">
                  <li>Platform</li>
                  <li>Solutions</li>
                  <li>Pricing</li>
                </ul>
              </div>
              <div>
                <h4 className="text-[24px] font-bold tracking-[-0.01em]">Brand Queries</h4>
                <p className="mt-2 text-[14px] text-muted">contact@flintpay.co</p>
              </div>
            </div>

            <div className="space-y-5 text-[14px] text-ink">
              <div>
                <h4 className="text-[24px] font-bold tracking-[-0.01em]">Resources</h4>
                <ul className="mt-3 space-y-2 text-muted">
                  <li>Blogs</li>
                  <li>Case Studies</li>
                  <li>Careers</li>
                </ul>
              </div>
              <div>
                <h4 className="text-[24px] font-bold tracking-[-0.01em]">Support</h4>
                <p className="mt-2 text-[14px] text-muted">contact@flintpay.co</p>
              </div>
            </div>

            <div className="space-y-5 text-[14px] text-ink">
              <div>
                <h4 className="text-[24px] font-bold tracking-[-0.01em]">FlintPay</h4>
                <p className="text-[14px] text-muted">Business Partner</p>
              </div>
              <div>
                <h4 className="text-[24px] font-bold tracking-[-0.01em]">Follow us</h4>
                <div className="mt-3 flex items-center gap-3 text-primary-800">
                  <span className="flex h-8 w-8 items-center justify-center rounded-full border border-primary-200 text-[12px] font-bold">ig</span>
                  <a
                    href="https://www.linkedin.com/company/flintpay/"
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label="FlintPay on LinkedIn"
                    className="flex h-8 w-8 items-center justify-center rounded-full border border-primary-200 text-[12px] font-bold transition hover:bg-primary-50"
                  >
                    in
                  </a>
                </div>
              </div>
            </div>
          </div>

          <div className="mt-10 grid gap-2 border-t border-line pt-6 text-[14px] font-medium text-ink sm:grid-cols-3 sm:text-center">
            <button type="button" className="text-left transition hover:text-primary-800 sm:text-center">Privacy Policy</button>
            <button type="button" className="text-left transition hover:text-primary-800 sm:text-center">Cookie Policy</button>
            <button type="button" className="text-left transition hover:text-primary-800 sm:text-center">Terms of Service</button>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
